/**
 * @file 从 UA 中解析系统
 */
import { getFirstMatch, isAndroid } from './utils';
export const osParser = [
    {
        test: /windows/i,
        describe(ua) {
            const version = getFirstMatch(/Windows ((NT|XP)( \d\d?.\d)?)/i, ua);
            return {
                name: 'Windows',
                version,
            };
        },
    },
    {
        test: /macintosh/i,
        describe(ua) {
            const version = getFirstMatch(/mac os x (\d+(\.?_?\d+)+)/i, ua).replace(/[_\s]/g, '.');
            return {
                name: 'macOS',
                version,
            };
        },
    },
    {
        test: /(ipod|iphone|ipad)/i,
        describe(ua) {
            const version = getFirstMatch(/os (\d+([_\s]\d+)*) like mac os x/i, ua).replace(/[_\s]/g, '.');
            return {
                name: 'iOS',
                version,
            };
        },
    },
    {
        test: isAndroid,
        describe(ua) {
            const version = getFirstMatch(/android[\s/-](\d+(\.\d+)*)/i, ua);
            return {
                name: 'Android',
                version,
            };
        },
    },
];
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoib3MuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi9zcmMvb3MudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBQUE7O0dBRUc7QUFFSCxPQUFPLEVBQUUsYUFBYSxFQUFFLFNBQVMsRUFBRSxNQUFNLFNBQVMsQ0FBQTtBQUVsRCxNQUFNLENBQUMsTUFBTSxRQUFRLEdBQUc7SUFDdEI7UUFDRSxJQUFJLEVBQUUsVUFBVTtRQUNoQixRQUFRLENBQUMsRUFBVTtZQUNqQixNQUFNLE9BQU8sR0FBRyxhQUFhLENBQUMsZ0NBQWdDLEVBQUUsRUFBRSxDQUFDLENBQUE7WUFFbkUsT0FBTztnQkFDTCxJQUFJLEVBQUUsU0FBUztnQkFDZixPQUFPO2FBQ1IsQ0FBQTtRQUNILENBQUM7S0FDRjtJQUNEO1FBQ0UsSUFBSSxFQUFFLFlBQVk7UUFDbEIsUUFBUSxDQUFDLEVBQVU7WUFDakIsTUFBTSxPQUFPLEdBQUcsYUFBYSxDQUFDLDRCQUE0QixFQUFFLEVBQUUsQ0FBQyxDQUFDLE9BQU8sQ0FDckUsUUFBUSxFQUNSLEdBQUcsQ0FDSixDQUFBO1lBRUQsT0FBTztnQkFDTCxJQUFJLEVBQUUsT0FBTztnQkFDYixPQUFPO2FBQ1IsQ0FBQTtRQUNILENBQUM7S0FDRjtJQUNEO1FBQ0UsSUFBSSxFQUFFLHFCQUFxQjtRQUMzQixRQUFRLENBQUMsRUFBVTtZQUNqQixNQUFNLE9BQU8sR0FBRyxhQUFhLENBQzNCLG9DQUFvQyxFQUNwQyxFQUFFLENBQ0gsQ0FBQyxPQUFPLENBQUMsUUFBUSxFQUFFLEdBQUcsQ0FBQyxDQUFBO1lBRXhCLE9BQU87Z0JBQ0wsSUFBSSxFQUFFLEtBQUs7Z0JBQ1gsT0FBTzthQUNSLENBQUE7UUFDSCxDQUFDO0tBQ0Y7SUFDRDtRQUNFLElBQUksRUFBRSxTQUFTO1FBQ2YsUUFBUSxDQUFDLEVBQVU7WUFDakIsTUFBTSxPQUFPLEdBQUcsYUFBYSxDQUFDLDZCQUE2QixFQUFFLEVBQUUsQ0FBQyxDQUFBO1lBQ2hFLE9BQU87Z0JBQ0wsSUFBSSxFQUFFLFNBQVM7Z0JBQ2YsT0FBTzthQUNSLENBQUE7UUFDSCxDQUFDO0tBQ0Y7Q0FDRixDQUFBIn0=